var _clipPath, _clipPath2, _clipPath3, _clipPath4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3095.32,-640.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747,157.888L747,256.888L819,256.888L819,184.888L792,157.888L747,157.888Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747,256.888L747,157.888L819,157.888L819,256.888L747,256.888Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M792,157.889L819,184.889L819,256.889L747,256.889L747,157.889L792,157.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(113,146,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.458,178.664C771.665,178.664 770.351,178.787 769.518,179.034C768.286,179.403 767.349,179.905 766.706,180.542C766.061,181.179 765.617,182.02 765.371,183.067C765.125,184.114 765.002,185.964 765.002,188.618C765.002,190.247 764.947,191.39 764.838,192.046C764.701,192.923 764.447,193.652 764.078,194.232C763.709,194.815 763.27,195.228 762.764,195.473C762.259,195.72 761.505,195.871 760.507,195.926L760.507,200.852C761.766,200.921 762.701,201.19 763.309,201.662C763.917,202.134 764.373,202.918 764.674,204.013C764.892,204.765 765.002,206.4 765.002,208.918C765.002,211.079 765.117,212.663 765.351,213.669C765.584,214.675 766.038,215.52 766.715,216.204C767.392,216.888 768.225,217.377 769.209,217.672C770.194,217.966 771.61,218.112 773.458,218.112L774.546,218.112L774.546,213.186C773.068,213.186 772.106,213.094 771.662,212.91C771.218,212.725 770.885,212.455 770.667,212.099C770.449,211.744 770.338,211.114 770.338,210.211C770.338,209.581 770.29,208.132 770.194,205.859C770.112,204.368 769.936,203.179 769.661,202.288C769.387,201.4 768.994,200.644 768.48,200.02C767.968,199.397 767.308,198.855 766.5,198.388C767.416,197.801 768.099,197.233 768.542,196.685C768.986,196.138 769.353,195.444 769.64,194.601C769.927,193.761 770.106,192.662 770.174,191.307C770.297,188.9 770.359,187.264 770.359,186.401C770.359,185.554 770.462,184.955 770.667,184.607C770.872,184.257 771.19,183.997 771.621,183.826C772.052,183.655 773.027,183.569 774.546,183.569L774.546,178.664L773.458,178.664Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760.507,218.112L760.507,178.664L774.546,178.664L774.546,218.112L760.507,218.112Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.763,178.664L790.763,183.569C792.31,183.569 793.305,183.662 793.749,183.847C794.193,184.032 794.501,184.296 794.673,184.636C794.845,184.979 794.937,185.663 794.95,186.689C795.019,189.946 795.127,192.053 795.279,193.011C795.512,194.407 795.948,195.556 796.592,196.459C797.056,197.089 797.796,197.731 798.808,198.388C798.028,198.84 797.389,199.363 796.89,199.958C796.389,200.554 795.989,201.28 795.688,202.134C795.388,202.989 795.203,204.129 795.135,205.552C795.024,207.905 794.968,209.499 794.96,210.334C794.953,211.168 794.845,211.761 794.632,212.11C794.419,212.458 794.088,212.725 793.635,212.91C793.184,213.094 792.228,213.186 790.763,213.186L790.763,218.112L791.851,218.112C793.643,218.112 794.957,217.99 795.791,217.743C797.036,217.374 797.98,216.871 798.624,216.235C799.268,215.599 799.709,214.753 799.947,213.7C800.186,212.645 800.307,210.792 800.307,208.138C800.307,206.524 800.361,205.388 800.471,204.731C800.622,203.856 800.878,203.127 801.24,202.545C801.602,201.964 802.038,201.55 802.544,201.304C803.05,201.057 803.803,200.907 804.802,200.852L804.802,195.926C803.542,195.858 802.606,195.587 801.99,195.114C801.374,194.643 800.915,193.861 800.614,192.764C800.41,191.999 800.307,190.363 800.307,187.859C800.307,185.698 800.186,184.114 799.947,183.107C799.709,182.103 799.253,181.254 798.583,180.562C797.913,179.872 797.084,179.382 796.099,179.095C795.114,178.808 793.698,178.664 791.851,178.664L790.763,178.664Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.763,218.112L790.763,178.664L804.802,178.664L804.802,218.112L790.763,218.112Z",
    style: {
      fill: "url(#_Linear6)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M792,184.888L819,184.888L792,157.888L792,184.888Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M778.5,171.388L792,157.888L819,184.888L805.5,198.388L778.5,171.388Z",
    style: {
      fill: "url(#_Linear8)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M792,157.889L819,184.889L792,184.889L792,157.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinejoin: "bevel",
      stroke: "rgb(113,146,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-10.6496,-0.277468)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "764px",
    y: "249.889px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 22,
      fill: "rgb(76,108,123)"
    }
  }, "JSON")))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,-99,99,-4.3e-06,783,256.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(200,212,219)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.7e-06,-39.4482,39.4482,-1.7e-06,767.526,218.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(134,155,166)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(64,98,113)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.7e-06,-39.4482,39.4482,-1.7e-06,797.782,218.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(134,155,166)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(64,98,113)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.5003,-13.5003,13.5003,13.5003,792,184.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81%",
    style: {
      stopColor: "rgb(197,209,216)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(146,166,177)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.fb603bfcb0444120b8aeb528735800a4.svg";
export { ForwardRef as ReactComponent };